import { createFileRoute } from '@tanstack/react-router'
import { SharedProfilePage } from '../../features/shared-profile/shared-profile-page'

export const Route = createFileRoute('/s/$token')({
  component: PublicProfileRoute,
})

function PublicProfileRoute() {
  const { token } = Route.useParams()
  return <SharedProfilePage token={token} />
}
